(function () {
  function alignFooterText() {
   var productTitle = document.querySelector('.card-gallery');
    var footerText = document.querySelector(
      '#shopify-section-sections--31440436887897__footer_m9NzUG .text-block'
    );
    if (!productTitle || !footerText) return;
    var offset = productTitle.getBoundingClientRect().left - footerText.getBoundingClientRect().left;
    footerText.style.paddingInlineStart = Math.max(0, offset) + 'px';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alignFooterText);
  } else {
    alignFooterText();
  }

  var observer = new MutationObserver(function () {
    if (document.querySelector('.card-gallery')) {
      alignFooterText();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(alignFooterText, 150);
  });
})();